import nhslsLogo from "../../assets/logos/nhsls_logo.png";
import eliteTournamentsLogo from "../../assets/logos/eliteTournaments_logo.png";
import iwclaTournamentSeriesLogo from "../../assets/logos/iwlcaTournamentSeries_logo.jpeg";
import hoganLaxLogo from "../../assets/logos/hoganLax_logo.png";
import trilogyLogo from "../../assets/logos/trilogy_logo.png";
import trilogyWhiteLogo from "../../assets/logos/trilogyLacrosseWhite_logo.png";
import robinsonSportsLogo from "../../assets/logos/robinsonSports_logo.png";
import crabsLaxLogo from "../../assets/logos/crabsLax_logo.png";
import topOfTheBayLogo from "../../assets/logos/topOfTheBay_logo.png";
import robinsonSportsWhiteLogo from "../../assets/logos/robinsonSportsWhite_logo.png";

const logos = [
  hoganLaxLogo,
  trilogyWhiteLogo,
  nhslsLogo,
  robinsonSportsWhiteLogo,
  eliteTournamentsLogo,
  //   crabsLaxLogo,
  //   topOfTheBayLogo,
];

export default function PartnerLogoCloud() {
  return (
    <div className="py-2 w-full">
      
      <div className="flex flex-wrap justify-center items-center gap-12 px-4">
        {logos.map((logo, idx) => (
          <div
            key={idx}
            className="h-16 w-40 flex items-center justify-center"
          >
            <img
              src={logo}
              alt=""
              className="h-full object-contain transition duration-300 ease-in-out"
            />
          </div>
        ))}
      </div>
      <p className="text-center text-white font-semibold text-md mt-2">
        Trusted by the best tournament partners in the game
      </p>
    </div>
  );
}
